/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from "react";
// @ts-ignore
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import usaStates from "./states";

import api from "api";
import { Store } from "StoreContext";
import { useLocation } from "react-router-dom";
import Loader from "components/Spinner/Spinner";
import "../../assets/css/mapbox.css";
import BlueDot from "../../assets/img/dot.svg";
import "../../assets/css/table.css";

const AccessTOKEN =
  "pk.eyJ1IjoiemlnemFnZ2VkMDQxMCIsImEiOiJjbTJrbmRqajUwMzQxMmxwejAzNzBqcWJvIn0.uETYRUCiTVjL1bGo-o5JHw";
// const AccessTOKEN = "";
mapboxgl.accessToken = AccessTOKEN;

const USAMapBox = ({ setMapType, setStateName, setFullStateName, brandId, orderId, batchId }) => {
  const mapContainerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const { user } = Store();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [mapStatesData, setMapStatesdata] = useState([]);
  const [mapCountryData, setMapCountrydata] = useState([]);
  const [period, setPeriod] = useState("all");

  const periods = [
    { label: "7 Days", value: "7d" },
    { label: "30 Days", value: "30d" },
    { label: "90 Days", value: "90d" },
    { label: "6 Months", value: "180d" },
    { label: "1 Year", value: "1y" },
    { label: "All Time", value: "all" },
  ];

  useEffect(() => {
    getMapData();
  }, [brandId, orderId, batchId, period]);

  const getMapData = async () => {
    try {
      setLoading(true);
      let queryUrl = `/codes/scan-stats/map`;
      const params = [];
      if (location.pathname.includes("brand")) params.push(`brandId=${user._id}`);
      else if (brandId) params.push(`brandId=${brandId}`);
      if (orderId) params.push(`orderId=${orderId}`);
      if (batchId) params.push(`requestId=${batchId}`);
      if (period) params.push(`period=${period}`);
      if (params.length > 0) queryUrl += `?${params.join("&")}`;
      const res = await api("get", queryUrl);
      setMapStatesdata(res?.statesData || []); // Ensure it's an array
      setMapCountrydata(res?.countryData || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };
  const getMaxValidCode = () => {
    if (!mapStatesData.length) return 0;
    return Math.max(...mapStatesData.map((item) => item.totalCodes || 0));
  };
  const maxValidCode = getMaxValidCode();
  // Function to determine color and opacity
  const getStateColorAndOpacity = (stateAbbreviation) => {
    const stateData = mapStatesData.find(
      (item) => item.state === stateAbbreviation
    );
    const validCode = stateData ? stateData.totalCodes : null;

    if (validCode) {
      let opacity
      if (validCode >= 1 && validCode <= 20) {
        opacity = parseFloat((0.1 + (validCode / 20) * 0.4).toFixed(5)); // Range from 0.1 to 0.5
      } else if (validCode > 20) {
        opacity = parseFloat((0.3 + ((validCode - 20) / (maxValidCode - 20)) * 0.4).toFixed(5)); // Range from 0.5 to 0.9
      } else {
        opacity = 0.1; // Default for invalid codes
      }
      return { color: "blue", opacity }; // Adjust the multiplier for opacity as needed
    } else {
      return { color: "gray", opacity: 0.1 }; // Default opacity for states without valid codes
    }
  };

  useEffect(() => {
    const fetchGeoJson = async () => {
      try {
        const response = await fetch(
          "https://raw.githubusercontent.com/PublicaMundi/MappingAPI/master/data/geojson/us-states.json"
        );
        const data = await response.json();
        // Create a mapping of state names to abbreviations
        const stateAbbrMap = {};
        usaStates.forEach((state) => {
          stateAbbrMap[state.name] = state.abbreviation;
        });

        // Set colors and opacity for each state based on the state data
        data.features.forEach((feature) => {
          const stateName = feature.properties.name;
          const stateAbbreviation = stateAbbrMap[stateName];
          const { color, opacity } = getStateColorAndOpacity(stateAbbreviation);

          feature.properties.color = color;
          feature.properties.opacity = opacity;
        });
        if (mapContainerRef.current) {
          // Remove existing map if it exists
          if (mapInstanceRef.current) {
            mapInstanceRef.current.remove();
          }

          // Create new map instance
          const mapInstance = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: {
              version: 8,
              sources: {},
              layers: [],
              glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            },
            attributionControl: false,
            center: [-93.0977, 41.878],
            zoom: window.innerWidth < 768 ? 2 : 3,
            maxZoom: window.innerWidth < 768 ? 4 : 6,
            minZoom: window.innerWidth < 768 ? 2 : 3,
          });

          // Store map instance in ref
          mapInstanceRef.current = mapInstance;

          mapInstance.on("load", () => {
            // Remove existing layers and sources if they exist
            if (mapInstance.getSource("states")) {
              mapInstance.removeLayer("state-labels");
              mapInstance.removeLayer("states-layer");
              mapInstance.removeSource("states");
            }

            // Add GeoJSON source for states
            mapInstance.addSource("states", {
              type: "geojson",
              data: data,
            });

            // Add state fill layer
            mapInstance.addLayer({
              id: "states-layer",
              type: "fill",
              source: "states",
              paint: {
                "fill-color": ["get", "color"],
                "fill-opacity": ["get", "opacity"],
              },
            });

            // Add state borders
            mapInstance.addLayer({
              id: "state-borders",
              type: "line",
              source: "states",
              paint: {
                "line-color": "#FFFFFF",
                "line-width": 2,
              },
            });

            // Setup popup
            const popup = new mapboxgl.Popup({
              closeButton: false,
              closeOnClick: false,
            });

            // Event handlers for popup
            mapInstance.on("mousemove", "states-layer", (e) => {
              const stateName = e.features[0]?.properties?.name;
              const stateAbbreviation = stateAbbrMap[stateName];
              const stateData = mapStatesData.find(
                (item) => item.state === stateAbbreviation
              );
              const validCode = stateData ? stateData.totalCodes : "";

              if (stateName && stateAbbreviation) {
                const popupContent = stateData
                  ? `<strong>${stateName} - Valid Code: ${validCode}</strong>`
                  : `<strong>${stateName}</strong>`;

                popup
                  .setLngLat(e.lngLat)
                  .setHTML(popupContent)
                  .addTo(mapInstance);
              }
            });

            mapInstance.on("mouseleave", "states-layer", () => {
              popup.remove();
            });

            // Listen for state click event
            mapInstance.on("click", "states-layer", (e) => {
              const stateName = e.features[0]?.properties?.name;
              const stateAbbreviation = stateAbbrMap[stateName];
              setStateName(stateAbbreviation)
              setFullStateName(stateName)
              // setMapType('state')

            });
          });
        }
      } catch (error) {
        console.error("Error fetching state boundaries:", error);
      }
    };

    void fetchGeoJson();

    // Cleanup function
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, [mapContainerRef, mapStatesData]);


  const combineStateData = (mapStatesData) => {
    return mapStatesData
      .filter(item => item.totalCodes > 0)
      .map(item => {
        const matchedState = usaStates.find(state => state.abbreviation === item.state);
        return {
          totalCodes: item.totalCodes,
          state: item.state,
          name: matchedState ? matchedState.name : null
        };
      })
      .sort((a, b) => b.totalCodes - a.totalCodes);
  };

  return (
    <div className="mapbox-main">
      <div className="inner-country-data">
        <div className="d-flex align-items-center" style={{ padding: "8px 0", gap: "8px", flexWrap: "wrap" }}>
          {periods.map((p) => (
            <button
              key={p.value}
              onClick={() => setPeriod(p.value)}
              style={{
                fontFamily: 'Outfit',
                fontWeight: 600,
                fontSize: '14px',
                backgroundColor: period === p.value ? '#362FD8' : '#F0F0F0',
                color: period === p.value ? '#fff' : '#333',
                border: 'none',
                borderRadius: '6px',
                padding: '6px 16px',
                cursor: 'pointer',
              }}
            >
              {p.label}
            </button>
          ))}
        </div>

        <div style={{ gap: '20px' }} className="d-flex flex-sm-row flex-column justify-content-between">
          {/* Top US States */}
          <div className="custom-table" style={{ flex: 1 }}>
            <div className="table-header"><h2 className="vs-section-title">Top US States</h2></div>
            <div className="table-body">
              {mapStatesData.length > 0 ? (
                combineStateData(mapStatesData).map((state, index) => (
                  <div className="table-row" key={index}>
                    <div className="dot-row">
                      <img src={BlueDot} alt="dot" />
                      {String(state.name || state.state || '')}
                    </div>
                    <div className="td-2">{state.totalCodes?.toLocaleString()}</div>
                  </div>
                ))
              ) : (
                <div className="table-row">
                  <span style={{ color: '#888' }}>No data available for US states.</span>
                </div>
              )}
            </div>
          </div>

          {/* Top US Cities */}
          <div className="custom-table" style={{ flex: 1 }}>
            <div className="table-header"><h2 className="vs-section-title">Top US Cities</h2></div>
            <div className="table-body">
              {mapStatesData.length > 0 ? (
                (() => {
                  const allCities = [];
                  for (const state of mapStatesData) {
                    for (const city of (state.cities || [])) {
                      if (city.totalCodes > 0) {
                        allCities.push({ city: city.city, state: state.state, totalCodes: city.totalCodes });
                      }
                    }
                  }
                  allCities.sort((a, b) => b.totalCodes - a.totalCodes);
                  return allCities.slice(0, 15).map((item, index) => (
                    <div className="table-row" key={index}>
                      <div className="dot-row">
                        <img src={BlueDot} alt="dot" />
                        {item.city}, {item.state}
                      </div>
                      <div className="td-2">{item.totalCodes?.toLocaleString()}</div>
                    </div>
                  ));
                })()
              ) : (
                <div className="table-row">
                  <span style={{ color: '#888' }}>No city data available.</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="mapbox-map-container"
      // style={{
      //   width: "98%",
      //   margin: "2% auto",
      //   height: "500px",
      //   position: "relative",
      //   borderRadius: "10px",
      // }}
      >
        {loading ? (
          <div
            className="mapbox-map-loader"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
              borderRadius: "10px",
              zIndex: 2,
            }}
          >
            <Loader />
          </div>
        ) : null}
        <div
          ref={mapContainerRef}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            visibility: loading ? "hidden" : "visible",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "#ffffff",
          }}
        />
      </div>
    </div>
  );
};

export default USAMapBox;
